import { REGISTER_USER, CONNECT_SOCKET } from '../dashboard/actions';

export default (previousState = null, { type, payload }) => {
    if (type === CONNECT_SOCKET) {
        return payload;
    }
    return previousState;
};
